var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonsGroup',{staticClass:"clothing-buttons"},_vm._l((_vm.fitChartsStore.types),function(button){return _c('button',{key:button.key,class:[_vm.fitChartsStore.newChart.type === button.key ? 'active' : ''],on:{"click":function($event){return _vm.change(button.key)}}},[_vm._v(" "+_vm._s(button.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }